import {
  ApiNamespaces,
  ApiService,
  IQueuedRequest,
  OneAPIOptions
} from '../../common'
import { BackofficeBranchesApi } from './backoffice'
import { Queue } from '../../queue'

export class Branches implements ApiNamespaces {
  app: ApiService
  backoffice: BackofficeBranchesApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new ApiService(name, sessionId, requestsQueue, options)
    this.backoffice = new BackofficeBranchesApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.app.invalidateAll()
    this.backoffice.invalidateAll()
  }
}
